import * as types from './Reports.types';
import Helpers from '../../../common/helpers/Helpers';
import Constants from '../../../common/constants/Constants';
import Store from '../../../redux/Store';

export const getReportsList = () => {
  const { reports } = Store.getState();

  if (!reports) {
    return Helpers.get(Constants.REPORTSLIST_URL);
  } else {
    return Promise.resolve(reports);
  }
};

export const getReportsListSuccess = reports => ({ type: types.GET_REPORTS_LIST_SUCCESS, reports });
